import { z } from "zod";
import { BaseFilterInputSchema } from "@/Schemas/BaseFilterInput";
import { RequestSourceTypeEnumSchema } from "@/Enums/RequestSourceTypeEnum";
import { RequestRecordTypeEnumSchema } from "@/Enums/RequestRecordTypeEnum";
import { RequestStateTypeEnumSchema } from "@/Enums/RequestStateTypeEnum";

export const ListingInputSchema = BaseFilterInputSchema.extend({
    requestTypes: z.array(z.number()).default([]),
    dateFrom: z.date().nullable().default(null),
    dateTo: z.date().nullable().default(null),
    stateTypes: z.array(RequestStateTypeEnumSchema).default([]),
    sourceType: RequestSourceTypeEnumSchema.nullable().default(null),
    sourceId: z.number().nullable().default(null),
    partner: z.string().nullable().default(null),
    partnerId: z.number().nullable().default(null),
    recordType: RequestRecordTypeEnumSchema.nullable().default(null),
    recordId: z.number().nullable().default(null),
    partnerEmail: z.string().nullish().default(null),
    processingTypes: z.array(z.number()).default([]),
});

export type ListingInput = z.infer<typeof ListingInputSchema>;